import { render } from "./UserProfile.vue?vue&type=template&id=ea826a3c&ts=true"
import script from "./UserProfile.ts?vue&type=script&lang=ts"
export * from "./UserProfile.ts?vue&type=script&lang=ts"

import exportComponent from "D:\\OdocsPortal\\odocsportal-frontend-master\\odocsportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QImg,QBtn});
